import { getAccessToken, getUserInfo } from './services/tokenService.js'
import { environment } from './enviroments/enviroment.js'
import { get } from 'svelte/store'
import { sessionExpiredModalShown, locale } from './store/stores.js'


const client_id = environment.oidc_client_id
const redirectUrl = environment.redirectUrl
const oidc_auth_path = environment.oidc_auth_path
const logoutUrl = environment.logoutUrl


export function startAuth() {
    const userSelectedLocale = get(locale)
    window.location.href = `${oidc_auth_path}?response_type=code&ui_locales=${userSelectedLocale}&client_id=${client_id}&redirect_uri=${redirectUrl}&scope=openid%20externalpermissions.query&state=976234769273492`
}

const setUserInfoToStorage = async () => {
    const userInfo = await getUserInfo()
    localStorage.setItem('userGroups', JSON.stringify(userInfo))
}

const setAccessTokenInfoToStorage = (accessInfo) => {
    localStorage.setItem('accessToken', accessInfo.access_token)
    localStorage.setItem('idToken', accessInfo.id_token)
    localStorage.setItem('tokenExpiresIn', accessInfo.expires_in)
    localStorage.setItem('isLoggedIn', true)
}

const clearUrlBar = () => {
    window.history.pushState({}, document.title, '/')
}

export const getHasAccess = async () => {
    const getAuthCode = window.location.href
    if (getAuthCode.includes('code=')) {
        const code = getAuthCode.substring(getAuthCode.indexOf('=') + 1, getAuthCode.indexOf('&'))
        const accessInfo = await getAccessToken(code)
        if (accessInfo.access_token) {
            setAccessTokenInfoToStorage(accessInfo)
            setUserInfoToStorage()
            setExpireSessionTimer()
        }
        clearUrlBar()
    } else if (getAuthCode.includes('error_description=')) clearUrlBar()
}

const setExpireSessionTimer = () => {
    const expireTimeInSecondsString = localStorage.getItem('tokenExpiresIn')
    const usedDuration = parseInt(expireTimeInSecondsString) * 1000
    setTimeout(() => {
        clearLocalStorageValues()
        showSessionExpiredModal()
    }, usedDuration)
}

const showSessionExpiredModal = () => {
    sessionExpiredModalShown.set(true)
}

const clearLocalStorageValues = () => {
    localStorage.removeItem('userGroups')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('idToken')
    localStorage.removeItem('tokenExpiresIn')
    localStorage.removeItem('isLoggedIn')
}

export function logOut() {
    clearLocalStorageValues()
    //const userSelectedLocale = get(locale)
    //const idToken = localStorage.getItem('idToken')
    window.location.href = logoutUrl
}


